import React from 'react';
import { Reveal } from '../Reveal';
import { TestimonialCard } from '../TestimonialCard';
import { testimoniosCompletos } from '../../data/content';
export function TestimoniosCompletos() {
  return <section aria-labelledby="testimonios-titulo" className="w-full bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-255" data-mp="16b8bonas06wy">
      <div className="mx-auto max-w-3xl" data-id="element-256" data-mp="1b8gw6ujecn1d">
        <Reveal data-id="element-257" data-mp="1bbmki7k7bkw1">
          <div className="text-center" data-id="element-258" data-mp="wkm3vf9awkot">
            <h2 id="testimonios-titulo" className="font-display text-3xl font-bold text-bordo sm:text-4xl" data-id="element-259" data-mp="wjko4xhcba0r">
              Lo que dicen las profes que ya lo usan:
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base text-tintasuave sm:text-lg" data-id="element-260" data-mp="nkh49racmql7">
              +300 profes de telas de todo el país ya tienen su Profes de Telas Resuelto™
            </p>
          </div>
        </Reveal>

        <div className="mt-10 flex flex-col gap-5 sm:gap-6" data-id="element-261" data-mp="dn2o7ssc83tf">
          {testimoniosCompletos.map((testimonio, index) => <Reveal key={testimonio.name} delay={Math.min(index, 3) * 0.04} data-id="element-262" data-mp="imxgo0rrh1gl" data-mpi={index}>
              <TestimonialCard testimonio={testimonio} data-id="element-263" data-mp="3s16l9bgi9oql" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}